import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import './zzz-element.scss';

interface IProps {
  rarity: string;
}

export const ZZZRarity: React.FC<IProps> = ({ rarity }) => {
  const popoverrarity = (
    <Popover id="popover-rarity">
      <Popover.Header as="h3">{rarity}</Popover.Header>
      <Popover.Body>
        {rarity} is one of the Agent ranks available in Zenless Zone Zero.
      </Popover.Body>
    </Popover>
  );
  return (
    <OverlayTrigger
      trigger="click"
      rootClose
      placement="auto-start"
      overlay={popoverrarity}
    >
      <div className={`zzz-rarity rar-${rarity}`}>
        {rarity === 'A' && (
          <>
            <StaticImage
              src="../../../../images/zzz/icons/rarity_a.png"
              alt="Rarity A"
              className="faction-icon"
            />
          </>
        )}
        {rarity === 'S' && (
          <>
            <StaticImage
              src="../../../../images/zzz/icons/rarity_s.png"
              alt="Rarity A"
              className="faction-icon"
            />
          </>
        )}
        {rarity === 'Unknown' && <>Unknown</>}
      </div>
    </OverlayTrigger>
  );
};
